import { motion } from "framer-motion";
import { steddyTransition } from "@/lib/animations";

const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const integrations = [
  "Salesforce",
  "HubSpot",
  "MCA Track",
  "Plaid",
  "DocuSign",
  "ACH Networks",
  "Experian",
  "Equifax",
  "TransUnion",
  "LexisNexis",
  "Slack",
  "Zapier",
];

const IntegrationsSection = () => (
  <section id="integrations" className="bg-secondary/30 py-32">
    <div className="container mx-auto px-6 text-center">
      <motion.div {...fadeInUp} transition={steddyTransition}>
        <span className="text-xs font-semibold uppercase tracking-wider text-primary">
          Ecosystem
        </span>
        <h2 className="mt-4 text-3xl font-bold text-foreground md:text-4xl">
          Connects to your stack
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
          Sync with your CRM, credit bureaus, payment processors, and communication tools — all out
          of the box.
        </p>
      </motion.div>

      <motion.div
        {...fadeInUp}
        transition={{ ...steddyTransition, delay: 0.15 }}
        className="mx-auto mt-12 flex max-w-3xl flex-wrap justify-center gap-3"
      >
        {integrations.map((name) => (
          <div
            key={name}
            className="steddy-transition card-surface-light rounded-full bg-background px-5 py-2.5 text-sm font-medium text-muted-foreground hover:text-primary hover:shadow-md"
          >
            {name}
          </div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default IntegrationsSection;
